import { memo, useEffect, useState } from 'react';

import { IconPlus01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import TooltipItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/TooltipItem';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { setComma } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface IProps {
  /** onClick */
  onClick?: () => void;
  /** isShortFormBtnTooltip */
  isShortFormBtnTooltip?: boolean;
  /** setTooltipShown */
  setTooltipShown?: (value: string) => void;
  /** styleClipTooltipPoint */
  styleClipTooltipPoint?: number;
}

const StyleClipAddBtn = ({
  onClick,
  styleClipTooltipPoint,
  isShortFormBtnTooltip,
  setTooltipShown,
}: IProps) => {
  const [motionEnded, setMotionEnded] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setMotionEnded(true);
    }, 5000);
  }, []);

  return (
    <S.StyleClipAddBtn>
      {!motionEnded && isShortFormBtnTooltip && styleClipTooltipPoint && (
        <TooltipItem
          text={`등록하면 최대 <em>${setComma(
            styleClipTooltipPoint?.toString() || '0'
          )}P</em> 지급`}
          type="rightCenter"
          onClose={() => setTooltipShown?.('Y')}
        />
      )}
      <Button
        className="style-clip-add-btn"
        onClick={onClick}
        label="스타일클립 추가하기"
        icon={<IconPlus01 />}
      />
    </S.StyleClipAddBtn>
  );
};

export default memo(StyleClipAddBtn);
